import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TRegion } from '../types/types';

const initialState:
    {
        Regions: TRegion[]

    } = {
    Regions: []
}

const Regions = createSlice({
    name: 'region',
    initialState,
    reducers: {
        addRegions: (state, action: PayloadAction<TRegion[]>) => {
            state.Regions = action.payload
        },
    },
});

export const { addRegions } = Regions.actions;

export default Regions.reducer;
